export const APP_PRIMARY_COLOR = '#2884ff';
export const VACCINE_APP_PRIMARY_COLOR = '#00B2CA';

export const APP = {
  FONT_FAMILY: {
    REGULAR: 'RobotoRegular',
    MEDIUM: 'RobotoMedium',
    // SEMI_BOLD: 'SFProSemiBold',
    BOLD: 'RobotoBold'
  },
  COLOR: {
    PRIMARY: APP_PRIMARY_COLOR,
    DEFAULT: {
      WHITE: '#FFF',
      BLACK: '#000'
    },
    BACKGROUND: {
      WARNING: '#ffe6e6',
      SCREEN: '#F9FAFC'
    },
    TABLE: {
      HEADER: '#F5F4F6'
    },
    FILTER: {
      BACKGROUND: '#EDEDED'
    },
    FONT: {
      PRIMARY: '#000'
    },
    TABS: {
      INDICATOR: '#fff',
      HEADER_INFO: '#F9FAFC'
    },
    NOTICE_TYPE: {
      FN: '#C03035',
      PD: '#F99132'
    },
    DIVIDER: {
      PRIMARY: '#B4CEF4'
    },
    BORDER: {
      SHADOW_CARD: '#BFD1E0'
    },
    NOTIFICATION_DELIVERY_STATUS: {
      SENT: '3CB371',
      FAILED: '#DC143C',
      PENDING: '#faa150', // #f19847 slight variation
      IGNORED: '#ab7967'
    },
    WELLCHECK_STATUS: {
      UPCOMING: APP_PRIMARY_COLOR,
      MISSED: '#EE7451',
      COMPLETED: '#4CA6A8',
      UNKNOWN: '#7B1FA2'
    },
    ELIGIBILITY_STATUS: {
      ACTIVE_COLOR: '#ffffff',
      ACTIVE_BORDER_COLOR: '#008000',
      ACTIVE_BACKGROUND_COLOR: 'rgba(33, 174, 47, 0.05)',
      IN_ACTIVE_COLOR: '#000000',
      IN_ACTIVE_BORDER_COLOR: '#d3d3d3',
      IN_ACTIVE_BACKGROUND_COLOR: 'rgba(211, 211, 211, 0.05)',
      NOT_APPLICABLE_COLOR: '#ffffff',
      NOT_APPLICABLE_BORDER_COLOR: '#ff0000',
      NOT_APPLICABLE_BACKGROUND_COLOR: 'rgba(255, 0, 0, 0.05)',
      NOT_VERIFIED_COLOR: '#FFFF00',
      NOT_VERIFIED_BORDER_COLOR: '#FFFF00',
      NOT_VERIFIED_BACKGROUND_COLOR: 'rgba(255, 255, 0, 0.05)'
    }
  },
  STATUS: {
    INFO: APP_PRIMARY_COLOR,
    SUCCESS: '#1AB23D',
    WARNING: '#ED944d',
    ERROR: '#b33f40',
    DEFAULT: '#54585b'
  },
  MESSAGES: {
    STATUS_DROPDOWN_BACKGROUND: '#D9E4EC'
  }
};

export const BACKGROUND_PRIMARY_COLOR = '#F5F4F6';
export const APP_SECONDARY_COLOR = '#1AB23D';

export const FONT_PRIMARY_COLOR = '#241a2e';
export const BORDER_SECONDARY_COLOR = '#0000003A';
export const tableSize = {
  '@media (min-width:1300px)': {
    // maxBodyHeight : '70vh',
    maxWidth: '90vw'
  }
};
export const FONT_SECONDARY_COLOR = '#54585b';
export const FONT_TERTIARY_COLOR = '#616161';
export const INPUT_LABEL_COLOR = FONT_PRIMARY_COLOR;

export const BORDER_PRIMARY_COLOR = '#d5d9e3';
export const DISABLED_GRAY_COLOR = '#5A5A5A';
export const DEFAULT_WHITE_COLOR = '#FFFFFF';
export const DEFAULT_RED_COLOR = '#FF0000';
export const DEFAULT_BLACK_COLOR = '#000000';
export const LIGHT_BLACK_COLOR = '#999292';
export const TAG_COLOR = '#0051d4';

export const WHITE_BACKGROUND_COLOR = '#fbfbfb';
export const DEFAULT_BACKGROUND_COLOR = 'rgba(224,232,247,1)';
export const GRID_TABLE_SELECTED_ROW = '#E9F6FF';
export const SWITCH_BASE_COLOR = '#1976d2';
export const SWITCH_BORDER_COLOR = APP_PRIMARY_COLOR;
export const SWITCH_TRACK_COLOR = '#E0E0E0';
export const TABLE_ODD_ROW_COLOR = '#F9FAFC';
export const TABLE_DARK_ODD_ROW_COLOR = '#e3e5e9';
export const TABLE_TERTIARY_COLOR = '#f5eed2b0';
export const BLACK_COLOR = '#151e24';
export const PAYMENTS_BACKGROUND_COLOR = APP_PRIMARY_COLOR;
export const BORDER_COLOR = '#c1c1c1';
export const PAYMENT_CARD_COLOR = '#44a791';
export const PAYMENT_SECONDARY_COLOR = '#f5eed2b0';
export const DETAIL_TABLE_BACKGROUND_COLOR = '#E8F0FF';
export const DEFAULT_BOX_SHADOW_COLOR = '#00000029';
export const INVOICES_TABLE_CELL_BORDER_COLOR = '#dadada';
export const STATE_OBJECT_BORDER = '#00000090';
export const STATE_OBJECT_OPACITY = 0.4;
export const ACTIVE_TAB_BACKGROUND_COLOR = 'rgba(26, 119, 255, 0.1)';
export const SELECTED_TAB_BACKGROUND_COLOR = 'rgba(0,0,0,0.25)';
export const SELECTED_SUBTAB_BACKGROUND_COLOR = 'rgba(0,0,0,0.15)';
export const INDICATOR_COLOR = 'rgba(0,0,0,0)';
export const BUTTON_DISABLE_COLOR = 'rgba(0, 0, 0, 0.26)';
export const DEFAULT_GREY_COLOR = '#8f8f90';
export const TEXT_GRAY_COLOR = '#838383';
export const LAST_IMPORTED_LEGEND_COLOR = '#EFF0F6';
export const ROW_EVEN_COLOR = 'rgb(0,0,0,0.05)';
export const DIVIDER_BLACK_COLOR = '#a0a0a0';
export const DEFAULT_DOC_FILE_BACKGROUND_COLOR = '#eeeeee';
export const DEFAULT_DOC_FILE_ICON_BACKGROUND_COLOR = '#80808080';
export const DEFAULT_YELLOW_COLOR = '#FFF176';
export const DEFAULT_GREEN_COLOR = '#2E7D32';
export const MESSAGE_GRID_HEADER_BACKGROUND_COLOR = '#FBFBFB';
export const MESSAGE_GRID_HEADER_COLOR = '#898989';

// Change scale
export const GET_8_PIXEL_BOX = (unit: number): string => {
  // multiple of 8 pixels and 'px' is default unit used
  return `${8 * unit}px`;
};

export const GROUP_TYPE_STYLES = '#c1c1c1';
export const ENTER_CARD_BUTTON = 'rgba(0, 98, 255, 1)';
export const SWIPE_BUTTON_COLOR = '#00897b';
export const VERIFIED_CARD_MACHINE_COLOR = '#008000ba';
export const BORDER_BOTTOM_COLOR = '#d3d3d380';
export const CANCEL_BUTTON_FONT_WEIGHT = '500 !important';
export const SELECTED_GRID_ROW_BACKGROUND_COLOR = '#66b2ff80';
export const CREATED_BY_COLOR = '54585bab';

export const DRAGGABLE_ITEM_BOX_SHADOW =
  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)';

export const CCM_DIALOG_HEADER_COLOR = '#151e24';
export const LOADING_DARK_OVERLAY_COLOR = 'rgba(0,0,0,0.1)';
export const LOADING_LIGHT_OVERLAY_COLOR = 'rgba(255,255,255, 0.7)';
export const CARD_BOX_SHADOW =
  '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)';
export const BENEFIT_INFORMATION_WRAPPER_BORDER_COLOR = '#eeeeee';
export const USER_DASHBOARD_ICON_COLOR = '#1D79FF';

export const NO_HIGHLIGHT_COLOR = DEFAULT_RED_COLOR;
export const DONT_KNOW_HIGHLIGHT_COLOR = '#ed5f00';

/**
 * Insurance Network Coverage Colors
 */
export const IN_NETWORK_COLOR = '#32A5FF';

export const MENU_ITEM_BORDER_BOTTOM_COLOR = '#eeeeee';

// TICKET PRIORITY CHIPS COLORS

export const PRIORITY_HIGH_COLOR = '#c03035';
export const PRIORITY_MEDIUM_COLOR = '#f99132';
export const PRIORITY_LOW_COLOR = '#1a73e8';
export const NO_PRIORITY_COLOR = '#e0e0e0';

export const EDITABLE_GRID_BORDER_COLOR = BORDER_PRIMARY_COLOR;
export const INPUT_BORDER_COLOR = '#838383';
export const CALENDAR_SELECTED_DAY_COLOR = '#006edc';
